/* HANIA STUDIO — Editorial layer: header, menu, cart drawer, PDP, card deck, hero slider, carousels, draggable WhatsApp, reveals */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  var ISO = (window.shopSettings && window.shopSettings.isoCode) || 'PKR';
  function money(cents) {
    var n = Math.round(cents) / 100;
    if (ISO === 'PKR') return n.toLocaleString('en-US', { maximumFractionDigits: 0 }) + '/-';
    var f = (window.shopSettings && window.shopSettings.moneyFormat) || '{{amount}}';
    var a = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, a).replace(/<[^>]*>/g, '');
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var root = (window.routes && window.routes.root_url) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- overlays ---------- */
  var scrim = $('[data-hx-scrim]');
  function openDrawer(d) { closeAll(); d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); if (scrim) scrim.classList.add('on'); document.documentElement.classList.add('hx-lock'); }
  function closeAll() {
    $$('.hx-drawer.open').forEach(function (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('on'); document.documentElement.classList.remove('hx-lock');
  }
  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  $$('[data-hx-close-drawer]').forEach(function (b) { b.addEventListener('click', closeAll); });

  /* ---------- header ---------- */
  var header = $('[data-hx-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var menu = $('[data-hx-menu-drawer]');
  $$('[data-hx-menu]').forEach(function (b) { b.addEventListener('click', function () { if (menu) openDrawer(menu); }); });
  if (menu) $$('a', menu).forEach(function (a) { a.addEventListener('click', closeAll); });

  /* ---------- cart drawer ---------- */
  var cartEl = $('[data-hx-cart]');
  function setCount(n) { $$('[data-hx-count]').forEach(function (c) { c.textContent = n; c.classList.toggle('hide', !n); }); }
  function renderCart(cart) {
    if (!cartEl) return;
    setCount(cart.item_count);
    var body = $('.hx-cart__body', cartEl), foot = $('.hx-cart__foot', cartEl);
    $('.hx-cart__n', cartEl).textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items.length) {
      body.innerHTML = '<div class="hx-cart__empty"><p>Your bag is empty.</p><a class="hx-btn" href="' + root + 'collections/all">Explore the collection</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map(function (it, i) {
      var vt = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="hx-li__v">' + esc(it.variant_title) + '</span>' : '';
      return '<div class="hx-li" data-line="' + (i + 1) + '">' +
        '<a class="hx-li__img" href="' + it.url + '">' + (it.image ? '<img src="' + sized(it.image, 200) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="hx-li__info"><a class="hx-li__t" href="' + it.url + '">' + esc(it.product_title) + '</a>' + vt +
        '<div class="hx-li__row"><div class="hx-qty hx-qty--sm"><button type="button" data-hx-line-q="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-hx-line-q="1" aria-label="Increase">+</button></div>' +
        '<span class="hx-li__p">' + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="hx-li__rm" data-hx-line-rm>Remove</button></div></div>';
    }).join('');
    $('.hx-cart__sub', cartEl).textContent = money(cart.total_price);
  }
  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function refreshCart(open) { return fetchCart().then(function (c) { renderCart(c); if (open && cartEl) openDrawer(cartEl); return c; }); }
  function changeLine(line, qty) {
    cartEl.classList.add('busy');
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart).finally(function () { cartEl.classList.remove('busy'); });
  }
  if (cartEl) {
    cartEl.addEventListener('click', function (e) {
      var li = e.target.closest('.hx-li'); if (!li) return;
      var line = parseInt(li.dataset.line, 10), q = parseInt($('.hx-qty span', li).textContent, 10);
      var b = e.target.closest('[data-hx-line-q]');
      if (b) changeLine(line, Math.max(0, q + parseInt(b.dataset.hxLineQ, 10)));
      if (e.target.closest('[data-hx-line-rm]')) changeLine(line, 0);
    });
    $$('[data-hx-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); }); });
  }
  document.addEventListener('cart:refresh', function () { refreshCart(true); });

  function addForm(form, thenCheckout) {
    var btn = $('[data-hx-add]', form) || $('[type="submit"]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { if (thenCheckout) { window.location.href = root + 'checkout'; return; } return refreshCart(true); })
      .catch(function (err) { alert((err && (err.description || err.message)) || 'Could not add to bag. Please try again.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-hs-ajax]')) return;
    e.preventDefault(); addForm(f, false);
  });
  $$('[data-hx-buynow]').forEach(function (b) { b.addEventListener('click', function () { var f = b.closest('form'); if (f) addForm(f, true); }); });

  /* ---------- PDP ---------- */
  $$('[data-hx-pdp]').forEach(function (pdp) {
    var dataEl = $('[data-hx-product]', pdp); if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent), variants = data.variants || [];
    var form = $('form.hx-form', pdp), idIn = $('[data-hx-id]', pdp), priceEl = $('[data-hx-price]', pdp);
    var addBtn = $('[data-hx-add]', pdp), buyBtn = $('[data-hx-buynow]', pdp);
    function selected() { return $$('.hx-chips', pdp).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; }); }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return sel[i] == null || sel[i] === o; }); })[0];
      sel.forEach(function (val, i) { var o = $('[data-hx-optval="' + i + '"]', pdp); if (o) o.textContent = val || ''; });
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; } return; }
      idIn.value = v.id;
      var h = (v.compare_at_price > v.price ? '<s class="hx-price__was">' + money(v.compare_at_price) + '</s>' : '') + '<span class="hx-price__now">' + money(v.price) + '</span>';
      if (priceEl) priceEl.innerHTML = h;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to Bag' : 'Sold Out'; }
      if (buyBtn) buyBtn.disabled = !v.available;
      var sp = $('.hs-satc__p'); if (sp) sp.textContent = money(v.price);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u); }
      if (sel.length === 1) $$('.hx-chip input', pdp).forEach(function (inp) {
        var m = variants.filter(function (x) { return x.options[0] === inp.value; })[0];
        inp.parentNode.classList.toggle('oos', !!m && !m.available);
      });
    }
    $$('.hx-chips input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    update();
    $$('[data-hx-q]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { var i = $('input[name="quantity"]', form); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + parseInt(b.dataset.hxQ, 10)); });
    });
    $$('[data-hx-open]', pdp).forEach(function (b) {
      b.addEventListener('click', function () { var d = document.getElementById(b.dataset.hxOpen); if (d && d.showModal) d.showModal(); });
    });
    $$('dialog', pdp).forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-hx-close]')) d.close(); });
    });
  });

  /* ---------- Card deck ---------- */
  $$('[data-hx-deck]').forEach(function (deck) {
    var stage = $('.hx-deck__stage', deck), cards = $$('.hx-deck__card', stage);
    var idx = $$('[data-hx-goto]', deck), count = $('[data-hx-dcount]', deck);
    if (!cards.length) return;
    var order = cards.map(function (_, i) { return i; }), n = cards.length;
    var list = $('.hx-deck__index', deck), ready = false;
    function pad(x) { return (x < 10 ? '0' : '') + x; }
    function layout() {
      order.forEach(function (ci, pos) {
        var c = cards[ci];
        c.style.zIndex = n - pos;
        c.style.transform = 'translate(' + (pos * 14) + 'px,' + (pos * -6) + 'px) rotate(' + (pos * 3.2) + 'deg) scale(' + (1 - pos * 0.045) + ')';
        c.style.opacity = pos > 3 ? 0 : 1;
        c.classList.toggle('top', pos === 0);
        c.setAttribute('tabindex', pos === 0 ? '0' : '-1');
      });
      if (count) count.textContent = pad(order[0] + 1) + ' / ' + pad(n);
      idx.forEach(function (a) { a.classList.toggle('on', parseInt(a.dataset.hxGoto, 10) === order[0]); });
      if (list) {
        var on = $('a.on', list);
        if (on) { var li = on.parentNode; list.scrollTo({ top: Math.max(0, li.offsetTop - li.offsetHeight), behavior: ready ? 'smooth' : 'auto' }); }
      }
      ready = true;
    }
    function next() { order.push(order.shift()); layout(); }
    function prev() { order.unshift(order.pop()); layout(); }
    function goto(i) { var guard = 0; while (order[0] !== i && guard++ < n) { order.push(order.shift()); } layout(); }
    var nb = $('[data-hx-next]', deck), pb = $('[data-hx-prev]', deck);
    if (nb) nb.addEventListener('click', next);
    if (pb) pb.addEventListener('click', prev);
    idx.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var i = parseInt(a.dataset.hxGoto, 10);
        if (order[0] !== i) { e.preventDefault(); goto(i); }
      });
    });
    var sx = 0, sy = 0, dx = 0, dragging = false, moved = false, top = null;
    stage.addEventListener('pointerdown', function (e) {
      top = e.target.closest('.hx-deck__card'); if (!top || !top.classList.contains('top')) { top = null; return; }
      dragging = true; moved = false; sx = e.clientX; sy = e.clientY; dx = 0; top.style.transition = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging || !top) return;
      dx = e.clientX - sx;
      if (Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(e.clientY - sy)) moved = true;
      if (moved) top.style.transform = 'translateX(' + dx + 'px) rotate(' + (dx / 18) + 'deg)';
    }, { passive: true });
    window.addEventListener('pointerup', function () {
      if (!dragging || !top) return;
      dragging = false; top.style.transition = '';
      if (moved && Math.abs(dx) > 70) { if (dx < 0) next(); else prev(); } else layout();
    });
    stage.addEventListener('click', function (e) {
      var c = e.target.closest('.hx-deck__card'); if (!c) return;
      if (moved) { e.preventDefault(); moved = false; return; }
      if (!c.classList.contains('top')) { e.preventDefault(); goto(cards.indexOf(c)); }
    });
    deck.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') next(); if (e.key === 'ArrowLeft') prev(); });
    layout();
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hx-slider]').forEach(function (s) {
    var slides = $$('.hx-slide', s), dots = $$('[data-hx-dot]', s), i = 0, timer = null;
    var delay = parseInt(s.dataset.delay || 6000, 10);
    if (slides.length < 2) return;
    function show(k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (el, j) { el.classList.toggle('on', j === i); el.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      dots.forEach(function (d, j) { d.classList.remove('on'); if (j === i) { void d.offsetWidth; d.classList.add('on'); } });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } s.classList.add('paused'); }
    function play() { stop(); s.classList.remove('paused'); timer = setInterval(function () { show(i + 1); }, delay); }
    var pv = $('[data-hx-sprev]', s), nx = $('[data-hx-snext]', s);
    if (pv) pv.addEventListener('click', function () { show(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { show(i + 1); play(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { show(j); play(); }); });
    s.addEventListener('mouseenter', stop); s.addEventListener('mouseleave', play);
    var tx = 0, ty = 0;
    s.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }, { passive: true });
    s.addEventListener('touchend', function (e) {
      var ddx = e.changedTouches[0].clientX - tx, ddy = e.changedTouches[0].clientY - ty;
      if (Math.abs(ddx) > 45 && Math.abs(ddx) > Math.abs(ddy)) { show(ddx < 0 ? i + 1 : i - 1); play(); }
    }, { passive: true });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });
    show(0); play();
  });

  /* ---------- Swipe carousels (product rows, reels) ---------- */
  $$('[data-hx-car]').forEach(function (car) {
    var tr = $('[data-hx-car-track]', car); if (!tr) return;
    var pv = $('[data-hx-car-prev]', car), nx = $('[data-hx-car-next]', car);
    var foot = car.nextElementSibling && car.nextElementSibling.matches('.hx-car__foot') ? car.nextElementSibling : null;
    var bar = foot ? $('.hx-car__bar i', foot) : $('.hx-car__bar i', car);
    function item() { return tr.querySelector('.hs-reel, .hx-card') || tr.firstElementChild; }
    function step() {
      var c = item(); if (!c) return tr.clientWidth;
      var cs = getComputedStyle(tr), gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      var w = c.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((tr.clientWidth + gap) / w)) * w;
    }
    function upd() {
      var max = tr.scrollWidth - tr.clientWidth, x = tr.scrollLeft;
      car.classList.toggle('no-scroll', max <= 2);
      if (foot) foot.classList.toggle('no-scroll', max <= 2);
      if (pv) pv.disabled = x <= 2;
      if (nx) nx.disabled = x >= max - 2;
      if (bar && tr.scrollWidth) {
        var vis = Math.min(100, tr.clientWidth / tr.scrollWidth * 100), p = max > 0 ? x / max : 0;
        bar.style.width = vis + '%'; bar.style.left = (p * (100 - vis)) + '%';
      }
    }
    if (pv) pv.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
    var raf = 0;
    tr.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd(); setTimeout(upd, 600);
  });

  /* ---------- Draggable WhatsApp bubble ---------- */
  var wa = $('.hs-wa');
  if (wa) {
    var st = null, dragged = false;
    wa.addEventListener('pointerdown', function (e) {
      var r = wa.getBoundingClientRect(); st = { x: e.clientX, y: e.clientY, l: r.left, t: r.top }; dragged = false;
      if (wa.setPointerCapture) wa.setPointerCapture(e.pointerId);
    });
    wa.addEventListener('pointermove', function (e) {
      if (!st) return;
      var mx = e.clientX - st.x, my = e.clientY - st.y;
      if (!dragged && Math.hypot(mx, my) < 8) return;
      dragged = true; wa.classList.add('drag');
      wa.style.left = Math.min(innerWidth - 56, Math.max(4, st.l + mx)) + 'px';
      wa.style.top = Math.min(innerHeight - 56, Math.max(4, st.t + my)) + 'px';
      wa.style.right = 'auto'; wa.style.bottom = 'auto';
    });
    wa.addEventListener('pointerup', function () {
      if (!st) return; st = null; wa.classList.remove('drag');
      if (dragged) { var r = wa.getBoundingClientRect(); wa.style.left = (r.left + 26 < innerWidth / 2 ? 14 : innerWidth - 66) + 'px'; }
    });
    wa.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); dragged = false; } });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); ro.unobserve(en.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.hx-reveal').forEach(function (el) { ro.observe(el); });
  } else { $$('.hx-reveal').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- Collection sort ---------- */
  $$('[data-hx-sort]').forEach(function (s) { s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }); });
})();
